import React from 'react';

const Frontend = () => {
  return (
    <div className='skills__content'>
      <h3 className='skills__title'>ML & GenAI</h3>

      <div className='skills__box'>
        {/* LEFT COLUMN */}
        <div className='skills__group'>
          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Machine Learning</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Generative AI</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>LLM Fundamentals</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>NLP</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN */}
        <div className='skills__group'>
          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>RAG (AI Search)</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>LangChain</h3>
              <span className='skills__level'>Proficient</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Azure OpenAI</h3>
              <span className='skills__level'>Intermediate</span>
            </div>
          </div>

          <div className='skills__data'>
            <i className='bx bx-badge-check'></i>
            <div>
              <h3 className='skills__name'>Prompt Flow</h3>
              <span className='skills__level'>Intermediate</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Frontend;
